<script lang="ts">
	import type { EventGalleryData } from '$lib/queries/EventGalleryQuery';
	import ScrollingEventGallery from '@comp/ScrollingEventGallery.svelte';
	import StaticEventGallery from '@comp/StaticEventGallery.svelte';

	let { data, index }: { data: EventGalleryData; index?: number } = $props();
</script>

{#if data.asHero}
	<ScrollingEventGallery {data} useBanner={index === 0}></ScrollingEventGallery>
{:else}
	<StaticEventGallery {data}></StaticEventGallery>
{/if}
